import { getAppData } from "app/getAppData";
import {
  setPuzzelOrgConfig,
  setPuzzelRuntimeConfig,
} from "app/PuzzelAuth/puzzelAuthConfig";
import { Amplify } from "aws-amplify";

let isConfigured = false;

export const configureAuth = async (): Promise<void> => {
  if (isConfigured) {
    return;
  }

  const {
    authUrl,
    clientId,
    userPoolId,
    puzzelClientId,
    puzzelIdpScheme,
    puzzelCiqType,
    puzzelPhoneNumberPrefix,
    puzzelFunctionalNumberPrefix,
    puzzelCountryCode,
    puzzelMaxAttempts,
    puzzelMaxOneRequestForPreferredAgent,
    puzzelPreferredAgentWaitTimeSeconds,
    puzzelQueueKey,
    puzzelReservedAgentWaitTimeSeconds,
    puzzelSecondsBetweenAttempts,
    cognito,
    puzzel,
  } = await getAppData();

  setPuzzelRuntimeConfig({
    clientId: puzzel?.clientId ?? puzzelClientId,
    idpScheme: puzzel?.idpScheme ?? puzzelIdpScheme,
  });

  setPuzzelOrgConfig({
    ciqType: puzzel?.ciqType ?? puzzelCiqType,
    phoneNumberPrefix: puzzel?.phoneNumberPrefix ?? puzzelPhoneNumberPrefix,
    functionalNumberPrefix:
      puzzel?.functionalNumberPrefix ?? puzzelFunctionalNumberPrefix,
    countryCode: puzzel?.countryCode ?? puzzelCountryCode,
    maxAttempts: puzzel?.maxAttempts ?? puzzelMaxAttempts,
    maxOneRequestForPreferredAgent:
      puzzel?.maxOneRequestForPreferredAgent ??
      puzzelMaxOneRequestForPreferredAgent,
    preferredAgentWaitTimeSeconds:
      puzzel?.preferredAgentWaitTimeSeconds ??
      puzzelPreferredAgentWaitTimeSeconds,
    queueKey: puzzel?.queueKey ?? puzzelQueueKey,
    reservedAgentWaitTimeSeconds:
      puzzel?.reservedAgentWaitTimeSeconds ??
      puzzelReservedAgentWaitTimeSeconds,
    secondsBetweenAttempts:
      puzzel?.secondsBetweenAttempts ?? puzzelSecondsBetweenAttempts,
  });

  const cognitoAuthUrl = cognito?.authUrl ?? authUrl;
  const cognitoClientId = cognito?.clientId ?? clientId;
  const cognitoUserPoolId = cognito?.userPoolId ?? userPoolId;

  if (!cognitoAuthUrl || !cognitoClientId || !cognitoUserPoolId) {
    throw new Error("Missing Cognito configuration in app-data");
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        loginWith: {
          oauth: {
            redirectSignIn: [`${window.location.origin}/login-redirect`],
            redirectSignOut: [`${window.location.origin}`],
            // Domain is set in terraform with https:// at the beginning, must be removed here to avoid double https in the URL
            domain: cognitoAuthUrl.replace("https://", ""),
            scopes: [],
            responseType: "code",
          },
        },
        userPoolId: cognitoUserPoolId,
        userPoolClientId: cognitoClientId,
      },
    },
  });

  isConfigured = true;
};
